import React from 'react';
import {Wrap, WrapItem} from '@chakra-ui/react';

import {FaUsersCog} from 'react-icons/fa';
import Card from '../../components/Maintenance/IconCard';

const routes = [{Name: 'A/R Entry 2', Icon: FaUsersCog, RouteName: 'ar-entry-2'}];

const ScottPrograms = props => {
  return (
    <div>
      <Wrap mt={'10'}>
        {routes.map((screen, idx) => {
          return (
            <WrapItem key={idx}>
              <Card name={screen.Name} icon={screen.Icon} route={'/scott-programs/' + screen.RouteName} />
            </WrapItem>
          );
        })}
      </Wrap>
    </div>
  );
};

export default ScottPrograms;
